import { createAutocompleteSelectors } from 'swag-client-common/redux/partials/autocomplete/autocomplete.selector';
const autocompleteRootSelector = state => state.autocomplete;
export const {
  autocompleteListSelector,
  isAddressLoadingSelector,
  isAddressEnteredManuallySelector,
  selectedOptionSelector
} = createAutocompleteSelectors(autocompleteRootSelector);